import React, { Component } from "react";
import { Buffer } from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import Cookies from "universal-cookie";
import { Button, Modal, Table, message, Form, Radio, Input } from "antd";
import { serviceBureauService } from "../../services/otodisApi/ServiceBureauService";
import { EditOutlined } from "@ant-design/icons";
import { SettingServiceBureauStates } from "./types/SettingServiceBureauTypes";
import withAuth from "../../hoc/withAuth";
import CurrencyInput from "react-currency-input-field";

export interface HomeProps {}

class SettingServiceBureau extends Component<HomeProps & any, SettingServiceBureauStates> {
  private readonly initState!: SettingServiceBureauStates;
  private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());
  private token = new Cookies().get("_t");
  private listIamDealer = JSON.parse(Buffer.from(new Cookies().get("_d"), "base64").toString());
  private tableColumn: any = [
    {
      title: "Kode Biro Jasa",
      dataIndex: "service_bureau_code",
      width: 80,
    },
    {
      title: "Nama Biro Jasa",
      dataIndex: "service_bureau_name",
      width: 150,
    },
    {
      title: "Izinkan Penugasan BBN",
      dataIndex: "allow_assig_bbn",
      width: 80,
      render: (value: boolean, row: any) => {
        return <span className={`font-90`}>{value?.toString()?.toUpperCase()}</span>;
      },
    },
    {
      title: "Izinkan Bayar BBN",
      dataIndex: "allow_generate_payment",
      width: 80,
      render: (value: boolean, row: any) => {
        return <span className={`font-90`}>{value?.toString()?.toUpperCase()}</span>;
      },
    },
    {
      title: "Nominal Biaya Jasa",
      dataIndex: "service_cost_nominal",
      width: 80,
      render: (value: number) => {
        return value.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      },
    },
    {
      title: "Izinkan API Integrasi",
      dataIndex: "assigment_api_integration_enabled",
      width: 80,
      render: (value: boolean, row: any) => {
        return <span className={`font-90`}>{value?.toString()?.toUpperCase()}</span>;
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 100,
      render: (value: string, row: []) => {
        return (
          <React.Fragment>
            <Button size={"small"} type={"primary"} onClick={(event) => this.showEditModal(row)}>
              {" "}
              <EditOutlined /> Edit
            </Button>
          </React.Fragment>
        );
      },
    },
  ];

  private exampleAssignmentApiOption = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer x=",
    },
    url: "https://example/api/v1/dealer/doc_type/batch_id",
  };

  constructor(props: (HomeProps & any) | any) {
    super(props);

    this.initState = {
      processing: false,
      processingFetchTableData: true,
      serviceBureauCode: props.match.params.dealerCode.replace(/-/g, "#"),
      dataSVB: [],
      pageSize: 100,
      showModalEdit: false,
      rowDetailSVB: [],
      radioAllowAssigBbn: false,
      radioAllowGeneratePayment: false,
      serviceCostNominal: 0,
      radioAssigmentApiIntegrationEnabled: false,
      assignmentApiOption: "",
      editProcess: false,
    };
    this.state = { ...this.initState };
  }

  closeModalEdit = (data: any) => {
    this.setState({
      showModalEdit: false,
    });
  };

  showEditModal = async (data: any) => {
    const formattedJson = Object.keys(data?.assigment_api_option)?.length > 0 ? JSON.stringify(data?.assigment_api_option, null, 2) : JSON.stringify(this.exampleAssignmentApiOption, null, 2);
    await this.promisedSetState({
      rowDetailSVB: data,
      radioAllowAssigBbn: data?.allow_assig_bbn,
      radioAllowGeneratePayment: data?.allow_generate_payment,
      radioAssigmentApiIntegrationEnabled: data?.assigment_api_integration_enabled,
      assignmentApiOption: formattedJson,
      serviceCostNominal: data?.service_cost_nominal,
      showModalEdit: true,
    });
  };

  onSVBChange = async (data: any) => {
    await this.promisedSetState({
      processingFetchTableData: true,
      serviceBureauCode: data.value,
    });

    await this.fetchSVBData();
  };

  fetchSVBData = async () => {
    await this.promisedSetState({
      processingFetchTableData: true,
    });

    await serviceBureauService.setToken(this.token);
    await serviceBureauService
      .GetServiceBureau({
        // dealerCode: this.state.dealerCode
      })
      .then(async (value) => {
        if (value?.data?.data?.length > 0) {
          await this.promisedSetState({
            dataSVB: value?.data?.data,
            processingFetchTableData: false,
          });
        } else {
          await this.promisedSetState({
            dataSVB: [],
            processingFetchTableData: false,
          });
          message.error("Data Tidak Ditemukan");
        }
      })
      .catch(async (reason) => {
        await this.promisedSetState({
          dataSVB: [],
          processingFetchTableData: false,
        });
        message.error("Data Tidak Ditemukan");
      });
  };

  onChangeTable = (pagination: any, filters: any, sorter: any) => {
    // console.log(pagination);
    // console.log(filters);
    // console.log(sorter);
    if (pagination?.pageSize) {
      this.setState({
        pageSize: pagination?.pageSize,
      });
    }
  };

  onFieldChange = async <T extends keyof Pick<any, "radioAllowAssigBbn" | "radioAllowGeneratePayment" | "radioAssigmentApiIntegrationEnabled" | "assignmentApiOption" | "serviceCostNominal">>(
    target: T,
    value: any
  ) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "radioAllowAssigBbn":
        currentState.radioAllowAssigBbn = value;
        break;

      case "radioAllowGeneratePayment":
        currentState.radioAllowGeneratePayment = value;
        break;
      case "radioAssigmentApiIntegrationEnabled":
        currentState.radioAssigmentApiIntegrationEnabled = value;
        break;
      case "assignmentApiOption":
        currentState.assignmentApiOption = value;
        break;
      case "serviceCostNominal":
        currentState.serviceCostNominal = value;
        break;
    }
    await this.promisedSetState({
      ...currentState,
    });
  };

  onSaveChanges = async () => {
    await this.promisedSetState({
      editProcess: true,
    });

    try {
      await serviceBureauService.setToken(this.token);
      await serviceBureauService
        .updateServiceBureau({
          service_bureau_code: this.state.rowDetailSVB?.service_bureau_code,
          allow_assig_bbn: this.state.radioAllowAssigBbn,
          allow_generate_payment: this.state.radioAllowGeneratePayment,
          assigment_api_integration_enabled: this.state.radioAssigmentApiIntegrationEnabled,
          assigment_api_option: JSON.parse(this.state.assignmentApiOption),
          service_cost_nominal: this.state.serviceCostNominal,
          updated_by: this.user,
        })
        .then(async (successData) => {
          Modal.success({
            title: "Proses Sukses",
            content: "Data Berhasil Di Update ",
          });
          this.defaultState();
          await this.fetchSVBData();
        });
    } catch (e) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e,
      });
      await this.promisedSetState({
        editProcess: false,
      });
    }
  };

  defaultState = async () => {
    await this.promisedSetState({
      showModalEdit: false,
      rowDetailSVB: [],
      radioAllowAssigBbn: false,
      radioAllowGeneratePayment: false,
      editProcess: false,
    });
  };

  async componentDidMount() {
    await this.fetchSVBData();
  }

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout
          noPadNoMar={true}
          onChangeDealer={this.onSVBChange}
          breadcrumbPath={`Setting`}
          breadcrumbMenu={`Service Bureau`}
          defaultSelectedKeys={["m-setting-service-bureau"]}
          defaultOpenKeys={["sm-setting"]}
        >
          <div style={{ paddingTop: 10 }}>
            <Table
              rowKey={"service_bureau_code"}
              size={"small"}
              scroll={{ x: "calc(500px + 50%)" }}
              loading={this.state.processingFetchTableData}
              columns={this.tableColumn}
              dataSource={this.state.dataSVB}
              pagination={{ pageSize: this.state.pageSize }}
              onChange={this.onChangeTable}
            />
          </div>
          <div />

          <Modal
            visible={this.state.showModalEdit}
            title="Edit Service Bureau"
            onOk={this.closeModalEdit}
            onCancel={this.closeModalEdit}
            cancelText={"Tutup"}
            okText={false}
            footer={[
              <Button type={"primary"} loading={this.state.editProcess} key="1" onClick={this.onSaveChanges}>
                Simpan Perubahan
              </Button>,
              <Button loading={this.state.editProcess} key="2" onClick={this.closeModalEdit}>
                Close
              </Button>,
            ]}
          >
            <Form layout="vertical">
              <Form.Item label="Izinkan Penugasan BBN ">
                <Radio.Group value={this.state.radioAllowAssigBbn} onChange={(event) => this.onFieldChange("radioAllowAssigBbn", event.target.value)}>
                  <Radio value={true}>TRUE</Radio>
                  <Radio value={false}>FALSE</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item label="Izinkan Bayar BBN ">
                <Radio.Group value={this.state.radioAllowGeneratePayment} onChange={(event) => this.onFieldChange("radioAllowGeneratePayment", event.target.value)}>
                  <Radio value={true}>TRUE</Radio>
                  <Radio value={false}>FALSE</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item label="Nominal Biaya Jasa ">
                <CurrencyInput className={"ant-input"} value={this.state.serviceCostNominal} onValueChange={(value) => this.onFieldChange("serviceCostNominal", value ? parseFloat(value) : 0)} />
              </Form.Item>
              <Form.Item label="Izinkan API Integrasi ">
                <Radio.Group value={this.state.radioAssigmentApiIntegrationEnabled} onChange={(event) => this.onFieldChange("radioAssigmentApiIntegrationEnabled", event.target.value)}>
                  <Radio value={true}>TRUE</Radio>
                  <Radio value={false}>FALSE</Radio>
                </Radio.Group>
              </Form.Item>

              {this.state.radioAssigmentApiIntegrationEnabled && (
                <Form.Item label="Assignment API Options">
                  <Input.TextArea rows={10} value={this.state.assignmentApiOption} onChange={(event: any) => this.onFieldChange("assignmentApiOption", event.target.value)} />
                </Form.Item>
              )}
            </Form>
          </Modal>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(SettingServiceBureau), 44);
